// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-336ad1a6] {\n  color: #b8c3e0;\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
